import { render, staticRenderFns } from "./folders-modal-archive.vue?vue&type=template&id=4e04d752&scoped=true"
import script from "./folders-modal-archive.vue?vue&type=script&lang=js"
export * from "./folders-modal-archive.vue?vue&type=script&lang=js"
import style0 from "./folders-modal-archive.vue?vue&type=style&index=0&id=4e04d752&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e04d752",
  null
  
)

export default component.exports